// extracted by mini-css-extract-plugin
module.exports = {"layout":"StandardLayout_layout__BDRuA","backToTop":"StandardLayout_backToTop__3XpO9"};